export const fieldTypes = [
  {
    key: 'text-field',
    label: 'Text Field'
  },
  {
    key: 'text-area',
    label: 'Text Area'
  },
  {
    key: 'select',
    label: 'Select'
  },
  {
    key: 'radio',
    label: 'Radio'
  },
  {
    key: 'check-box',
    label: 'Check Box'
  }
]
export const defaultForm = [
  {
    isDefault: true,
    type: 'text-field',
    required: true,
    show: true,
    options: [],
    name: "name",
    label: "Name",
    placeholder: "Enter your name",
  },
  {
    isDefault: true,
    type: 'text-field',
    required: true,
    show: true,
    options: [],
    name: "email",
    label: "Email",
    placeholder: "Enter your email",
  },
  {
    isDefault: true,
    type: 'text-field',
    required: true,
    show: true,
    options: [],
    name: "phone",
    label: "Phone",
    placeholder: "Enter your phone",
  },
  {
    isDefault: true,
    type: 'text-area',
    required: false,
    show: true,
    options: [],
    name: "message",
    label: "Message",
    placeholder: "Enter your message",
  },
]